import loadable from '@loadable/component';

export const SurveyJSWidget = loadable(() =>
  import('./SurveyJSWidget/SurveyJSWidget'),
);
